import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import Loader from "../components/generic/loader";
// import Toaster from "../components/generic/toaster";
// import { toasterSlice } from "../redux/reducers";
import LayoutComponent from "../components/layout/index";
import Lend from "../components/pages/dashboard/components/mainpage/lend/Lend";
import Collect from "../components/pages/dashboard/components/mainpage/collect/collect";

const Routers = () => {

    const fetchState = useSelector(state => ({ loader: state?.loader, toaster: state?.toaster?.data }));

    const appRoutes = (
        <Routes>
            <Route path="/" element={<LayoutComponent />}>
                <Route path="/dashboard">
                    <Route path="/dashboard/lend" element={<Lend />} />
                    <Route path="/dashboard/collect" element={<Collect />} />
                </Route>
            </Route>
        </Routes>
    );

    // const handleCloseToaster = e => {
    //     e === 'close' && dispatch(toasterSlice?.actions?.toasterReducer(null));
    // }

    return <>
        <Router>{appRoutes}</Router>
        <Loader loading={fetchState?.loader?.isLoading} />
        {/* {fetchState.toaster && (
            <Toaster
                information={fetchState?.toaster?.information}
                error={fetchState?.toaster?.error}
                success={fetchState?.toaster?.success}
                warning={fetchState?.toaster?.warning}
                center={fetchState?.toaster?.center}
                header={fetchState?.toaster?.header}
                undo={fetchState?.toaster?.undo}
                buttontext={fetchState?.toaster?.buttontext}
                hideclose={fetchState?.toaster?.hideclose}
                handleUndoClose={handleCloseToaster}
                top={fetchState?.toaster?.top}
            />
        )} */}
        {/* {accessTokenState?.data &&
            <AccessToster label='Oops! Something went wrong' description='Your token seems to be expired' onReload={handleReload} />
        } */}
    </>
}

export default Routers;